import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const useDiscrepancyEmailEffect = ({
  discrepancyUsageValueExist,
  discrepencyUpdatedDetails,
  dispatch,
  setDiscrepancyUsageValueExist,
  emailInputBoxes,
  setEmailInputBoxes,
  setDiscrepancyEmailIds,
  myCaseRefId,
}) => {
  useEffectWithErrorLogging(() => {
    if (discrepancyUsageValueExist) {
      if (discrepencyUpdatedDetails?.discrepancyDto?.emailIds) {
        dispatch(setDiscrepancyUsageValueExist(false));
        const emailIdsData =
          discrepencyUpdatedDetails?.discrepancyDto?.emailIds.split(',');
        if (emailIdsData?.length > 0) {
          let newEmailArray = emailIdsData?.map((item) => ({
            value: item,
            errorMessage: '',
          }));
          if (
            (emailInputBoxes?.length === 1 && emailInputBoxes?.[0].value !== '') ||
            emailInputBoxes?.length > 1
          ) {
            newEmailArray.push(...emailInputBoxes);
            newEmailArray = Array.from(
              new Set(newEmailArray.map((item) => item?.value))
            );
            newEmailArray = newEmailArray?.map((item) => ({
              value: item,
              errorMessage: '',
            }));
          }
          setEmailInputBoxes(newEmailArray);
          dispatch(setDiscrepancyEmailIds(newEmailArray));
        } else {
          const newEmailArray = [
            {
              value: '',
              errorMessage: '',
            },
          ];
          setEmailInputBoxes(newEmailArray);
          dispatch(setDiscrepancyEmailIds(newEmailArray));
        }
      } else if (discrepencyUpdatedDetails?.discrepancyDto?.emailIds === '') {
        const newEmailArray = [
          {
            value: '',
            errorMessage: '',
          },
        ];
        setEmailInputBoxes(newEmailArray);
        dispatch(setDiscrepancyEmailIds(newEmailArray));
      }
    }
  }, [myCaseRefId, discrepencyUpdatedDetails]);
};